import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { acceptAttachments } from '../handler/AiChatAttachmentHandler';
import FileIcon from '@/component/common/icons/FileIcon';

const UploadFile = forwardRef(function UploadFile({
    corporationDetail,
    projectInuseDetail,
    chatThreadId,
    uploadImgs = [],
    uploadFiles = [],
    setUploadImgs,
    setUploadFiles,
    showButton = true
}, ref) {
    const fileInputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    useImperativeHandle(ref, () => ({
        triggerClick: () => {
            fileInputRef.current?.click();
        }
    }));

    // Accept any file type: images and documents are split inside acceptAttachments
    const handleSelectFiles = (event) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (selectedFiles.length > 0) {
            acceptAttachments(selectedFiles, {
                uploadImgs,
                uploadFiles,
                setUploadImgs,
                setUploadFiles,
                enqueueSnackbar,
                corporationDetail,
                projectInuseDetail,
                chatThreadId
            });
        }
        event.target.value = ''; // reset after selected
    };

    return (
        <div>
            {showButton && (
                <button
                    className="btn-reset-default ai-chat-input-btn"
                    onClick={() => fileInputRef.current?.click()}
                >
                    <FileIcon width={20} height={16} />
                </button>
            )}
            <input
                style={{ display: 'none' }}
                ref={fileInputRef}
                type="file"
                multiple
                onChange={handleSelectFiles}
            />
        </div>
    );
});

UploadFile.propTypes = {
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    chatThreadId: PropTypes.string,
    uploadImgs: PropTypes.array,
    uploadFiles: PropTypes.array,
    setUploadImgs: PropTypes.func,
    setUploadFiles: PropTypes.func,
    showButton: PropTypes.bool
};

export default UploadFile;
